module.exports = __webpack_public_path__ + "img/circle-plus.f9faf611.svg";